import { ChakraV3, Command, FloatingPopover } from '@piccolohealth/ui';
import { P } from '@piccolohealth/util';
import React from 'react';
import { useFormContext } from 'react-hook-form';

type Context = {
  templates: string[];
  onSelect: (template: string) => void;
};

interface ParticipantBehaviourRecordingTemplateButtonProps {
  name: string;
  templates: string[];
}

export const ParticipantBehaviourRecordingTemplateButton = (
  props: ParticipantBehaviourRecordingTemplateButtonProps,
) => {
  const { name, templates } = props;

  const { setValue, getValues } = useFormContext();

  const context = React.useMemo(() => {
    return {
      templates,
      onSelect: (template: string) => {
        const existingValue = getValues(name) ?? '';
        const newValue = P.isEmptyString(existingValue) ? template : `${existingValue} ${template}`;
        setValue(name, newValue);
      },
    };
  }, [templates, name, setValue, getValues]);

  const getPages = React.useCallback((context: Context): Command.Page<Context>[] => {
    return [
      {
        kind: 'actions',
        id: 'ROOT',
        title: <ChakraV3.Text>Templates</ChakraV3.Text>,
        rawTitle: 'Templates',
        searchable: false,
        actions: context.templates.map((template, index) => {
          return {
            kind: 'void',
            id: index.toString(),
            title: () => <ChakraV3.Text>{template}</ChakraV3.Text>,
            rawTitle: template,
            action: () => {
              context.onSelect(template);
            },
          };
        }),
      },
    ];
  }, []);

  return (
    <FloatingPopover
      render={(props) => (
        <Command.CommandMenu
          onOpenChange={props.context.onOpenChange}
          getPages={getPages}
          ctx={context}
        />
      )}
    >
      <ChakraV3.Button size='xs' variant='plain'>
        Add from template
      </ChakraV3.Button>
    </FloatingPopover>
  );
};
